// extracted by mini-css-extract-plugin
module.exports = {"button":"button-social_button__iubgU","icon":"button-social_icon__aft2O"};